var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "dialogs" },
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.main.show
        ? _c("DefaultDialogView", {
            attrs: { "dialog-model": _vm.main },
            on: { closeDialog: _vm.closeDialog },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loader.show
        ? _c("LoaderDialogView", { attrs: { "dialog-model": _vm.loader } })
        : _vm._e(),
      _vm._v(" "),
      _vm.auth.show
        ? _c("AuthDialogView", {
            attrs: { "dialog-model": _vm.auth },
            on: { closeDialog: _vm.closeDialog },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error.show
        ? _c("DefaultDialogView", {
            attrs: { "dialog-model": _vm.error },
            on: { closeDialog: _vm.closeDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }